import { render, staticRenderFns } from "./UserNotificationOrderActionButton.vue?vue&type=template&id=a274a98a&scoped=true&"
import script from "./UserNotificationOrderActionButton.vue?vue&type=script&lang=js&"
export * from "./UserNotificationOrderActionButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a274a98a",
  null
  
)

export default component.exports